// extracted by mini-css-extract-plugin
export default {"table-head-row":"styles_table-head-row__2v6SG"};